/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespNegotiable_item$ref = any;
type SbRespProminentTileDescription_item$ref = any;
type SbRespTradeSourcingBanner_itemSearch$ref = any;
type SbSharedItemTrackingProvider_itemSearch$ref = any;
type SbSharedMeasurementUnitProvider_itemSearch$ref = any;
type SharedItemTile_item$ref = any;
export type SbRespSearchResultContainer_itemSearch$ref = any;
export type SbRespSearchResultContainer_itemSearch = {
    readonly displayUriRef: string | null;
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly serviceId: string | null;
                readonly lowestShipmentQuote?: ReadonlyArray<{
                    readonly isFreeToBuyer: boolean | null;
                } | null> | null;
                readonly " $fragmentRefs": SbRespProminentTileDescription_item$ref & SharedItemTile_item$ref & SbRespNegotiable_item$ref;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedMeasurementUnitProvider_itemSearch$ref & SbSharedItemTrackingProvider_itemSearch$ref & SbRespTradeSourcingBanner_itemSearch$ref;
    readonly " $refType": SbRespSearchResultContainer_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespSearchResultContainer_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayUriRef",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemSearchQueryEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "serviceId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SbRespProminentTileDescription_item",
                                    "args": null
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SharedItemTile_item",
                                    "args": null
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SbRespNegotiable_item",
                                    "args": null
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isTrade",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "lowestShipmentQuote",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isFreeToBuyer",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedMeasurementUnitProvider_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedItemTrackingProvider_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespTradeSourcingBanner_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b6dd5850ef89f3fe98213df4b96cc544';
export default node;
